import { Tag } from 'antd';
import FilterInput from "components/Form/filterInput";
import { useCallback,useEffect,useState } from "react";

import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toTitleCase } from "utils/common";


import { Button } from "components/Button";


const UniformListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading}) => {
  const {
    department, departmentLoading    ,
    position, positionLoading
} = useSelector((state) => state.common);

const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {

   console.log(filters, "---filters in setinputvalueeeeeee")
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{
      console.log('useEffeeect')
    if(!positionLoading){

      console.log(filters, "LLLs")

      let _appliedFilters = [...filters].map(item=>{
        let label = ""
        let value = ""
        switch(item.key){        
              case "position":
                let selectedDept = [...position].find(item=>item.id ==  searchParams.get("position") || "")
                value = selectedDept?.name
                label = "Position"
                break;
                case "gender":
                  let _gender = searchParams.get("gender") 
                  let selectedGender = _gender === 'M' ? 'Male' : _gender === 'F' ? 'Female' : _gender === 'U' ? 'Unisex' : '';

                  value = selectedGender
                  label = "Gender"
                  break;
                  case "status":
                  let _status = searchParams.get("status") || ""                  
                  let selectedStatus =  ( _status == "true") ? 'Active' :  ( _status == "false") ? 'Inactive' : '';
                  value = selectedStatus
                  label = "Status"
                  break;
            case "search":
              value = toTitleCase(searchParams.get("search") || "")
              label = "Search term"
              break;
        
          default:
            label = ""
            value = ""
        }
        return {
          ...item,
          value,
          label
        }
      })
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
    }

 
  },[
    position, 
    searchParams
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-10 ">
        <div className="row" >
        <div className='col-sm-12 col-lg-4' >
        <FilterInput  
         defaultValue={setInputValue("search")} 
         onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
          id="search"
           label={searchPlaceholder}
            />
        </div>
        <div className='col-sm-12  col-lg-8  mt-1 flex-wrap' >
          
        {
            appliedFilters.map(item=>{
              return (
                <Tag icon={loading&&<i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} className="mb-1" color={"red"} closeIcon={<i class="fa fa-times" aria-hidden="true"></i>} onClose={e=>handleClose(e, item)}>
                  {
                    item?.label
                  }
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              )
            })
          }

        </div>

        </div>
     
      
        </div>
      
 
        <div className="col-2 d-flex justify-content-end" style={{ paddingRight: 0 }}>
        <div className="view-icons">
        <Button onClick={handleFilterDrawer} icon="las la-filter"
        //  id="collapse-header" 
         className="list-view btn btn-link "/>
        </div>
       
        </div>
      </div>
    </div>
  );
};

export default UniformListFilter;
